<template>
    <div>
        <template v-if="userPermissions.indexOf('can_access_manager_directory') > -1">
            <!--Start Middle content-->
            <!--Start internal page banner section-->
            <section class="internal-page-banner-main col-12 manager-directory-page">
                <div class="container">
                    <div class="row">
                        <div class="page-title">
                            <h1> Manager Directory </h1>
                        </div>
                        <template v-if="role.id <= 1">
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2 pull-right mb-4 pl-0">
                                <label>Search By Name :</label>
                                <input v-model="name" type="text" class="form-control" id="name" placeholder="Name" maxlength="190">
                            </div>
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2 pull-right mb-4 pl-0">
                                <label>Search By Positon :</label>
                                <input v-model="position" type="text" class="form-control" id="position" placeholder="Position" maxlength="190">
                            </div>
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2 pull-right mb-4 pl-0">
                                <label>Search By Department :</label>
                                <v-select class=""
                                            v-model="department"
                                            name="department"
                                            id="department"
                                            label="text"
                                            :clearable="true"
                                            :searchable="true"
                                            :filterable="false"
                                            :options="departmentArr"
                                            @search="onSearchDept"
                                            placeholder="Select Department">
                                </v-select>
                                <!-- <input v-model="department" type="text" class="form-control" id="department" placeholder="Department" maxlength="190"> -->
                            </div>
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2 pull-right mb-4 pl-0">
                                <label>Search By Location :</label>
                                <v-select class=""
                                            v-model="location"
                                            name="location"
                                            id="location"
                                            label="text"
                                            :clearable="true"
                                            :searchable="true"
                                            :filterable="false"
                                            :options="locationArr"
                                            @search="onSearchLoc"
                                            placeholder="Select Location">
                                </v-select>
                                <!-- <input v-model="location" type="text" class="form-control" id="location" placeholder="Location" maxlength="190"> -->
                            </div>
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2 pull-right mb-4 pl-0">
                                <label>Search By State :</label>
                                <v-select class=""
                                        v-model="region"
                                        name="region"
                                        id="region"
                                        label="text"
                                        :clearable="true"
                                        :searchable="true"
                                        :filterable="false"
                                        :options="regionArr"
                                        @search="onSearchRegion"
                                        placeholder="Select State">
                                </v-select>
                                <!-- <input v-model="region" type="text" class="form-control" id="region" placeholder="Region" maxlength="190"> -->
                            </div>
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2 pull-right mb-4 pl-0 pt-4 mt-2">
                                <button type="submit" class="back_button btn apply-filter-btn p-1" v-on:click.prevent="loadManagerDirectory()">Apply Filter</button>
                                <button type="submit" class="back_button btn clear-filter-btn p-1" v-on:click.prevent="clearFilter()">Clear Filter</button>
                            </div>
                        </template>
                    </div>
                </div>
            </section>
            <!--End internal page banner section-->
            <div class="internal-page-main-section employee-recognisation-main col-12">
                <div class="container">
                    <div class="row">
                        <div class="bottom-manager-section float-l col-12">
                            <!-- manager pic section -->
                            <div class="row">
                                <template v-if="managerDirDataArr.length > 0">
                                    <template v-for="(managerData, index) in managerDirDataArr">
                                        <div :key="index" class="col-3 form-group">
                                            <template v-if="managerData.profile_image.full_path != ''">
                                                <img class="manager-main-pic" :src="managerData.profile_image.full_path" :alt="managerData.name">
                                            </template>
                                            <template v-else>
                                                <img class="manager-main-pic" src="/static/images/default.jpg" :alt="managerData.name">
                                            </template>
                                            <div class="manager-des-detail">
                                                <div class="manager-des-detail-name float-l width-full">
                                                    <p class="color-blue heading-text-18 line-height-25 font-text-semi-medium-mont">{{ managerData.name }}</p>
                                                </div>
                                                <div class="manager-des-detail-name float-l width-full">
                                                    <p class="color-888888 heading-text-14 line-height-25 font-text-semi-medium-mont">{{ managerData.post }}</p>
                                                </div>
                                                <div class="manager-des-detail-name float-l width-full">
                                                    <p class="color-red heading-text-16 line-height-25">{{ managerData.department_name }} in {{ managerData.location }}, {{ managerData.state}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <div class="data-not-found color-blue">
                                        {{noDataMessaage}}
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>

                    <!-- Pagination Start -->
                    <div class="vgt-wrap__footer managerDirPagination">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 PerPage">
                                <v-select title="Select Per Page"
                                            v-model="perPage"
                                            @input="changePerPage"
                                            name="customPerPage"
                                            id="customPerPage"
                                            label="text"
                                            :clearable="false"
                                            :searchable="false"
                                            :filterable="false"
                                            :options="paginationDropDownArr"
                                            placeholder="Select Per Page">
                                </v-select>
                            </div>
                            <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                <p class="pageRowCount">
                                    {{startEndRecord}} of {{totalRecords}}
                                </p>
                            </div>

                            <!-- v-if="totalRecords >= perPage" -->
                            <div class="col-sm-12 col-md-6 Pagination">
                                <b-pagination style="margin: 0px;" v-if="totalRecords > 0" align="center" :limit="5" prev-text="‹ Previous" next-text="Next ›" :total-rows="totalRecords" v-model="currentPage" @input="changepage()" :per-page="perPageValue"></b-pagination>
                            </div>

                            <div class="col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                <p class="pageJumpLabel">Page : </p>
                            </div>
                            <div class="col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                <input v-model="jumpToPage" type="text" class="form-control form-control-sm jumpToPage" name="jumpToPage" id="jumpToPage" v-on:keyup.enter="keyMonitor()" placeholder="Page">
                            </div>
                        </div>
                    </div>
                    <!-- Pagination End -->
                </div>
            </div>
            <!--End Middle content-->
        </template>
        <template v-else>
            <section class="internal-page-banner-main col-12">
                <div class="container">
                    <div class="row">
                        <div class="page-title">
                            <h1> Oops! </h1>
                        </div>
                    </div>
                </div>
            </section>
            <div class="internal-page-main-section contact-page-main col-12">
                <!--bottom-contact-detail-->
                <div class="row">
                    <div class="container">
                        <div class="social-media-calendar bottom-employee-detail col-12 float-l">
                            <div class="row">
                                <h2 class="color-red heading-text-24 line-height-28 font-text-semi-medium-mont float-l width-full error-code"> 403 </h2>
                                <div class="row">
                                    <div class="bottom-employee-detail-left col-12">
                                        <div class="bg-color-table mt-20 float-l width-full">
                                            Sorry!, You don't have permission to access this page.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
    var self;
    import Vue from "vue";
    import SessioMixin from '../mixins/sessionmixin';
    import {HTTP} from '../http-common';
    import vSelect from 'vue-select';
    import EventBus from './event-bus';

    export default {
        name: 'ManagerDirectory',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect
        },
        data() {
            return {
                name : '',
                position : '',
                department : '',
                departmentArr : [],
                location : '',
                locationArr: [],
                region : '',
                regionArr: [],

                managerDirDataArr : [],
                noDataMessaage: 'Details not available!',

                perPage: 12,
                paginationDropDownArr: [6, 12, 24, 48, 96, 500, "All"],
                startEndRecord : "",
                totalRecords: 0,
                currentPage: 1,
                jumpToPage: 1,
                tooManyDataForAllList : 'Too many data to display, Please apply some filters to reduce resulting data.',
                listExecutionState : false,
                userPermissions: ['can_access_manager_directory']
            }
        },
        watch: {
            region: function (region) {
                var region = (self.region === null || self.region == '') ? '' : self.region.value;
                if(region != '') {
                    self.location = '';
                    self.locationArr = [];
                    self.department = '';
                    self.departmentArr = [];
                    
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        params: {
                            location: region
                        }
                    };
                    HTTP.get("/get/mngrDirLocation", config)
                            .then(function (response) {
                                self.locationArr = response.data.content;
                            })
                            .catch(function (err) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                }
                            });
                } else {
                    self.loadLocations();
                    if((self.location === null || self.location == '')) {
                        self.loadDepartments();
                    }
                }
            },
            location: function (location) {
                var location = (self.location === null || self.location == '') ? '' : self.location.value;
                if(location != '') {
                    self.department = '';
                    self.departmentArr = [];

                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        params: {
                            site: location
                        }
                    };
                    HTTP.get("/get/mngrDirDepartment", config)
                            .then(function (response) {
                                self.departmentArr = response.data.content;
                            })
                            .catch(function (err) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                }
                            });
                } else {
                    if((self.region === null || self.region == '')) {
                        self.loadDepartments();
                    } else {
                        self.department = '';
                        self.departmentArr = [];
                    }
                }
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.MenuClose();
            self.getBuildVersion();

            self.loadDepartments();
            self.loadLocations();
            self.loadRegions();
            self.listExecutionState = false;
            self.loadManagerDirectory();
        },
        methods: {
            changePerPage : function(){
                self.currentPage = 1;
                if (self.perPage !== "All") {
                    self.perPageValue = self.perPage;
                }
                self.loadManagerDirectory();
            },
            changepage : function(){
                if(!self.listExecutionState){
                    self.loadManagerDirectory();
                }
            },
            keyMonitor: function() {
                var tempNumber = self.jumpToInputPage(self.jumpToPage, self.totalRecords, self.perPage);
                self.currentPage = self.jumpToPage = parseInt(tempNumber);
            },
            clearFilter() {
                self.name = '';
                self.position = '';
                self.department = '';
                self.location = '';
                self.region = '';
                self.jumpToPage = 1;
                self.keyMonitor();

                self.loadDepartments();
                self.loadLocations();
                self.loadRegions();
                self.loadManagerDirectory();
            },
            loadDepartments(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var config = {};
                if (search != '') {
                    config =  {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        params: {
                            search: search, 
                            get_all: 1
                        }
                    };
                } else {
                    config =  {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        params: {
                            get_all: 1
                        }
                    };
                }
                HTTP.get("/get/mngrDirDepartment", config)
                        .then(function (response) {
                            self.departmentArr = [];
                            self.departmentArr = response.data.content;
                            
                            if (typeof (loading) != "undefined") {loading(false);}
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadLocations(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var config = {};
                if (search != '') {
                    config =  {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        params: {
                            search: search, 
                            get_all: 1
                        }
                    };
                } else {
                    config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        params: {
                            get_all: 1
                        }
                    };
                }
                HTTP.get("/get/mngrDirLocation", config)
                        .then(function (response) {
                            self.locationArr = [];
                            self.locationArr = response.data.content;

                            if (typeof (loading) != "undefined") {loading(false);}
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadRegions() {
                HTTP.post("getlocation")
                    .then(function (response) {
                        self.regionArr = [];
                        $.each(response.data.content, function (i) {
                            if (response.data.content[i].value != 0) {
                                self.regionArr.push(response.data.content[i]);
                            }
                        });

                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                        }
                    });
            },
            loadSearchRegions(loading, search, vm) {
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            self.regionArr = [];
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    self.regionArr.push(response.data.content[i]);
                                }
                            });
                            if (typeof (loading) != "undefined") {loading(false);}
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            onSearchDept(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") { loading(true); }
                    this.loadDepartments(loading, search, this);
                }
            },
            onSearchLoc(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") { loading(true); }
                    this.loadLocations(loading, search, this);
                }
            },
            onSearchRegion(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") { loading(true); }
                    this.loadSearchRegions(loading, search, this);
                }
            },
            loadManagerDirectory : function () {
                self.listExecutionState = true;
                if(self.perPage == 'All' && self.totalRecords > process.env.MAX_SINGLEPAGE_DATA){
                    self.perPage = 500;
                    self.loadManagerDirectory();
                }
                let locationId = '';
                if(self.location && self.location.text != '') {
                    locationId = self.location.text;
                }
                let departmentId = '';
                if(self.department && self.department.text != '') {
                    departmentId = self.department.text;
                }
                let regionId = '';
                if(self.region && self.region.text != '') {
                    regionId = self.region.text;
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    name: self.name,
                    position: self.position,
                    region: regionId /* self.region */,
                    location: locationId /* self.location */,
                    department: departmentId /* self.department */,
                    per_page: self.perPage,
                    page: self.currentPage,
                };
                self.showLoader();
                HTTP.post('/manager/directory/list', fields, config)
                    .then(function (response) {
                        self.listExecutionState = false;
                        if (response.data.code == '200') {
                            self.totalRecords = response.data.content.data.totalRecords;
                            self.managerDirDataArr = response.data.content.data.row;
                        }

                        if (response.data.content.per_page !== self.totalRecords) {
                            self.perPage = parseInt(response.data.content.per_page);
                            self.jumpToPage = parseInt(response.data.content.current_page);
                        } else {
                            if(self.perPage == 'All'){
                                self.jumpToPage = 1;
                            }
                            self.perPageValue = self.totalRecords;
                            self.currentPage = 1;
                        }
                        self.startEndRecord = self.calculateStartRecordEndRecord(self.currentPage, self.perPage, self.totalRecords);
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        }
                        self.hideLoader();
                    })
            }
        }
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
        }
    });
</script>
<style>
.employee-recognisation-main .data-not-found{
    font-size: 40px;
    font-weight: bold;
    text-align: center;
    width: 100%;
}
.internal-page-banner-main label{
    color: white;
    margin-bottom: 0;
}
.internal-page-main-section {
    float: left;
    padding-top: 0 !important;
    padding-bottom: 6em;
    position: relative;
    width: 100%;
}
.internal-page-banner-main .apply-filter-btn {
    background-color: #115491;
    color:white;
}
.internal-page-banner-main .clear-filter-btn {
    background-color: #115491;
    color: white;
}
.manager-directory-page .v-select.unsearchable input[type=search] {
    /* display: none; */
    opacity: 1;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
}
.manager-directory-page .v-select.unsearchable input[type=search]::placeholder {
    font-size: 16px;
}
.manager-directory-page .v-select.unsearchable .dropdown-toggle .vs__selected-options{
    position: relative;
}
.manager-directory-page .v-select.unsearchable .dropdown-toggle {
    height: 44px;
}
.managerDirPagination {
    width: 100%;
    padding: 12px 12px 8px 12px !important;
}

.managerDirPagination p.pageJumpLabel {
    margin-top: 5px;
}

.managerDirPagination .jumpToPage {
    border: 1px solid #ced4da;
    border-radius: 5px;
    font-size: 1rem;
    padding: 5px 0.5rem 5px 0.5rem !important;
    font-family: 'SanFranciscoDisplayRegular' !important;
}
.error-code {
    margin-top: 20px;
    font-size: 26px;
}
</style>


// WEBPACK FOOTER //
// src/components/ManagerDirectory.vue